import { useChecklist } from '@/hooks/useChecklist'
import { ChecklistTopic } from './ChecklistTopic'
import styles from './ChecklistPage.module.css'

export function ChecklistPage() {
  const { state, progress, actions, isLoading, isSaving, error } = useChecklist()

  if (isLoading) {
    return (
      <div className={styles.page}>
        <div className={styles.header}>
          <h1 className={styles.title}>Checklist da administração</h1>
          <p className={styles.subtitle}>Carregando...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.page}>
        <div className={styles.header}>
          <h1 className={styles.title}>Checklist da administração</h1>
          <p className={styles.subtitle} style={{ color: 'var(--color-error, #c00)' }}>
            {error}
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Checklist da administração</h1>
        <p className={styles.subtitle}>
          Acompanhe e marque as tarefas por tópico. Os dados são salvos
          automaticamente no servidor.
          {isSaving && ' (Salvando...)'}
        </p>
        {progress.total > 0 && (
          <div className={styles.progressWrap}>
            <div
              className={styles.progressBar}
              role="progressbar"
              aria-valuenow={progress.percentage}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label="Progresso do checklist"
            >
              <div
                className={styles.progressFill}
                style={{ width: `${progress.percentage}%` }}
              />
            </div>
            <span className={styles.progressText}>
              {progress.completed} de {progress.total} concluídos (
              {progress.percentage}%)
            </span>
          </div>
        )}
      </div>

      <div className={styles.toolbar}>
        <button
          type="button"
          className={styles.addTopicBtn}
          onClick={actions.addTopic}
          aria-label="Adicionar tópico"
        >
          Adicionar tópico
        </button>
      </div>

      <div className={styles.topics}>
        {state.topics.length === 0 ? (
          <p className={styles.empty}>
            Nenhum tópico ainda. Clique em &quot;Adicionar tópico&quot; para
            começar.
          </p>
        ) : (
          state.topics.map((topic, index) => (
            <ChecklistTopic
              key={topic.id}
              topic={topic}
              onUpdateTopic={(updates) => actions.updateTopic(topic.id, updates)}
              onRemoveTopic={() => actions.removeTopic(topic.id)}
              onMoveTopic={(direction) => actions.moveTopic(topic.id, direction)}
              onAddItem={() => actions.addItem(topic.id)}
              onUpdateItem={actions.updateItem}
              onRemoveItem={actions.removeItem}
              onMoveItem={(itemId, direction) =>
                actions.moveItem(topic.id, itemId, direction)
              }
              onAddSubitem={actions.addSubitem}
              onUpdateSubitem={actions.updateSubitem}
              onRemoveSubitem={actions.removeSubitem}
              onMoveSubitem={actions.moveSubitem}
              canMoveUp={index > 0}
              canMoveDown={index < state.topics.length - 1}
            />
          ))
        )}
      </div>
    </div>
  )
}
